'use strict';

(function ($) {
	$(document).ready(function () {
		var albumContainers = $('.nextgen_pro_grid_album').find('.image_container');

		function makeCaptionSameWidthAsImage() {
			if (albumContainers.length > 0) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = albumContainers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var container = _step.value;

						var imageWidth = $(container).find('img').outerWidth();
						$(container).find('.caption_link').width(imageWidth);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
		}

		if (albumContainers.length > 0) {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = albumContainers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var container = _step2.value;

					var caption = $(container).find('.caption_link').detach();
					$(container).find('.nextgen_pro_lightbox').first().append(caption);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}

		makeCaptionSameWidthAsImage();
		$(window).on('resize', function () {
			return makeCaptionSameWidthAsImage();
		});
	});

	$(window).on('load', function () {

		// START ISOTOPE the galleria plugin album grid
		var $galleriaAlbum = $('.ngg-pro-album.nextgen_pro_grid_album');
		var $galleriaGalleriesContainer = $('.nextgen_pro_thumbnail_grid');

		$galleriaAlbum.addClass('sms-album').removeClass('ngg-pro-album').removeClass('nextgen_pro_grid_album');

		$galleriaAlbum.find('.image_container').addClass('sms-album-item').removeClass('image_container');

		$galleriaGalleriesContainer.addClass('sms-gallery').removeClass('nextgen_pro_thumbnail_grid');

		$galleriaGalleriesContainer.find('.image-wrapper').addClass('sms-gallery-item').removeClass('image-wrapper');

		$galleriaGalleriesContainer.prepend('<div class="gutter-sizer"></div>');

		$galleriaGalleriesContainer.find('img').attr('width', '').attr('height', '');

		cleanIsotopeGallery($galleriaAlbum, {
			layoutMode: 'masonry'
		});
		cleanIsotopeGallery($galleriaGalleriesContainer, {
			layoutMode: 'masonry',
			masonry: {
				columnWidth: 245,
				fitWidth: true,
				gutter: '.gutter-sizer'
			}
		});
		// END ISOTOPE the galleria plugin album grid
	});

	function cleanIsotopeGallery($el, $options) {
		if ($el.length > 0) {
			// remove all inline styles
			$el.attr('style', '').attr('id', '');

			$el.find('*').attr('style', '');
			setTimeout(function () {
				$el.isotope($options);
			}, 0);

			$(window).resize(function () {
				setTimeout(function () {
					$el.isotope('layout');
				}, 0);
			});
		}
	}
})(jQuery);